import { memo, useMemo } from 'react'
import { RaContainer, RaHeading, RaRichText } from '@components/core/index.core'
import { Loop } from '@utilities/helpers/core.helpers'
import { RaAccordion } from '@components/features/RaAccordion/RaAccordion'

import type { AcfExpansionpanelProps } from '@typings'

import styles from './acf-expansion-panel.module.scss'

export const AcfExpansionPanel = memo(
  ({ title, content, options }: AcfExpansionpanelProps) => {
    const accordions = useMemo(() => {
      if (!options || options?.length < 1) return null
      return Loop(options, (accordion, i: number) => (
        <RaAccordion
          key={i}
          title={accordion.option}
          content={accordion.option_content}
        />
      ))
    }, [options])

    return (
      <div className={styles['expansion-panel']}>
        <RaContainer>
          <div className={styles['expansion-panel__content']}>
            <div>
              {title && <RaHeading component="h2">{title}</RaHeading>}
              {content && <RaRichText content={content} />}
            </div>
            <div>{accordions}</div>
          </div>
        </RaContainer>
      </div>
    )
  }
)
